import {
  InvoiceFormatEnum,
  InvoiceSortFieldEnum,
  InvoiceSortOrderEnum,
  InvoiceStatusEnum,
} from '@invoice/shared/schemas';
import { z } from 'zod';

export const InvoiceListSearchSchema = z.object({
  page: z.coerce.number().int().min(1).optional(),
  pageSize: z.coerce.number().int().min(1).max(200).optional(),
  tenantId: z.string().min(1).optional(),
  status: InvoiceStatusEnum.optional(),
  format: InvoiceFormatEnum.optional(),
  sellerSearch: z.string().min(1).optional(),
  issueDateFrom: z.string().date().optional(),
  issueDateTo: z.string().date().optional(),
  sort: InvoiceSortFieldEnum.optional(),
  order: InvoiceSortOrderEnum.optional(),
});

export type InvoiceListSearch = z.infer<typeof InvoiceListSearchSchema>;

export const INVOICE_LIST_SEARCH_DEFAULTS = {
  page: 1,
  pageSize: 20,
  sort: 'createdAt' as const,
  order: 'desc' as const,
};

export type MaterialisedInvoiceListSearch = typeof INVOICE_LIST_SEARCH_DEFAULTS & InvoiceListSearch;
